import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import {Collapse} from 'react-collapse';

import { connect } from 'react-redux';
import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS } = helpers;

import GraduationIcon from 'assets/icons/graduation-cap';

import PQMetricsClassroom from './PQMetricsClassroom';
import PQ2MetricsClassroom from './PQ2MetricsClassroom';
import PFMetricsClassroom from './PFMetricsClassroom';

import '../../../sass/components/ui-list';
import { getTimestampToDate } from '../../util/index';
import './metrics.scss';

class MetricsPanelListItem extends Component {

    constructor (props) {
        super(props);

        this.state = {isOpened: this.props.selectedClassroom ? this.props.selectedClassroom === this.props.classroom.id : false};
    }

    toggle(){
        let isOpened = this.state.isOpened;
        this.setState({
            isOpened: !isOpened
        });
    }

	render () {
        if(!this.props.order){
            return <div>Loading</div>
        }

        let isOpened = this.state.isOpened;
        let startDate = this.props.order.startDate ? getTimestampToDate(this.props.order.startDate).format('MM/DD/YYYY') : '';
        let endDate = this.props.order.endDate ? getTimestampToDate(this.props.order.endDate).format('MM/DD/YYYY') : '';

        let metricsClassroom = null;
        switch(this.props.classroom.product){
            case 'pupsquestforphonicsschool1':
                metricsClassroom = (<PQMetricsClassroom classroom={this.props.classroom}/>);
                break;
            case 'phonemefarmschool':
                metricsClassroom = (<PFMetricsClassroom classroom={this.props.classroom}/>);
                break;
            case 'pupsquestforphonicsschool2':
                metricsClassroom = (<PQ2MetricsClassroom classroom={this.props.classroom}/>);
                break;
        }

		return (
			<div className="">
                <div className="metrics-classroom">
                    <div className="class-summary"
                         onClick={this.toggle.bind(this)}
                    >
                        <div className="classroom align-left">
                            <span className="avatar metrics-avatar"><InlineSVG src={GraduationIcon} element="span" className="icon" /></span>
                            <span className="classroom-name">{this.props.classroom.name}</span>
                        </div>
                        <div className="class-details align-right">
                            <div>{this.props.product.name}</div>
                            <div>Date of License: {startDate} - {endDate}</div>
                        </div>
                    </div>
                    <div className="class-list">
                        <Collapse isOpened={isOpened}>
                            {metricsClassroom}
                        </Collapse>
                    </div>
                </div>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
    return {};
};

const fbWrappedComponent = firebaseConnect([
    // `/classrooms/${props.classroomId}`
])(MetricsPanelListItem);

export default connect(
    ({ firebase, classroomId }) => ({
        // classroom: dataToJS(firebase, `/classrooms/${classroomId}`)
    }),
    mapDispatchToProps
)(fbWrappedComponent);


// WEBPACK FOOTER //
// ./js/components/Metrics/MetricsPanelListItem.js